import api from "../../services/api";

const useTemplateMessage = () => {

    const save = async (data) => {
        const { data: responseData } = await api.request({
            url: '/template-message',
            method: 'POST',
            data
        });
        return responseData;
    }

    const update = async (data) => {
        const { data: responseData } = await api.request({
            url: `/template-message/${data.id}`,
            method: 'PUT',
            data
        });
        return responseData;
    }

    const deleteRecord = async (id) => {
        const { data } = await api.request({
            url: `/template-message/${id}`,
            method: 'DELETE'
        });
        return data;
    }

    const list = async (params) => {
        const { data } = await api.request({
            url: '/template-message/list',
            method: 'GET',
            params
        });
        return data;
    }

    const importFromMeta = async (whatsappId) => {
        const { data } = await api.request({
            url: `/template-message/import`,
            method: 'POST',
            data: { whatsappId }
        });
        return data;
    }

    const submitToMeta = async (id) => {
        const { data } = await api.request({
            url: `/template-message/${id}/submit-to-meta`,
            method: 'POST'
        });
        return data;
    }

    return {
        save,
        update,
        deleteRecord,
        list,
        importFromMeta,
        submitToMeta
    }
}

export default useTemplateMessage;